import React from 'react';
import {Link} from 'react-router-dom';
import routes from 'globals/routes';

const TestPage = () => {
  return <div>This is test<Link to={routes.indexPage}>Index</Link></div>
}

export default TestPage;